(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-slider"] && !Shopify.designMode) return;
  try {
    
function initStorySlider(section) {
  const overlay = section.querySelector('.story-overlay');
  const closeBtn = section.querySelector('.story-modal-close');
  const muteBtn = section.querySelector('.story-modal-mute');
  const prevBtn = section.querySelector('.prev-btn');
  const nextBtn = section.querySelector('.next-btn');
  const modalBody = section.querySelector('.story-modal-body');
  const activeImg = section.querySelector('.story-active-img');
  const activeVideo = section.querySelector('.story-active-video');
  const bgBlur = section.querySelector('.story-modal-bg-blur');
  const loader = section.querySelector('.story-loader');
  const progressBarsContainer = section.querySelector('.story-progress-bars');
  const modalTitle = section.querySelector('.story-modal-title');
  const modalSubtitle = section.querySelector('.story-modal-subtitle');
  const modalAvatar = section.querySelector('.story-modal-avatar');
  const modalActionBtn = section.querySelector('.story-modal-action-btn');
  const swipeUpIndicator = section.querySelector('.swipe-up-indicator');
  const modalBodyText = section.querySelector('.story-modal-body-text');
  const modalTextContent = section.querySelector('.story-modal-text-content');

  const defaultDuration = parseInt(section.dataset.duration, 10) || 5000;
  const transitionEffect = section.dataset.transition || 'none';
  const enableBlur = section.dataset.blur === 'true';

  let currentStory = null;
  let currentSlideIndex = 0;
  let progressFrame, lastFrameTime = 0, timeElapsed = 0;
  let progressFills = [];
  let isVideoSlide = false, isSlideLoading = false, isPaused = false;
  let isGlobalMuted = true;
  let isSwiping = false; // Mobilde kaydırırken tıklamayı engelleme kilidi

  const storyScripts = section.querySelectorAll('script[data-story-block]');
  const stories = Array.from(storyScripts).map(s => JSON.parse(s.textContent));
  if (!stories.length) return;

  function buildProgressBars(slideCount) {
    progressBarsContainer.innerHTML = '';
    progressFills = [];
    for (let i = 0; i < slideCount; i++) {
      const fill = document.createElement('div');
      fill.className = 'story-progress-fill';
      const item = document.createElement('div');
      item.className = 'story-progress-item';
      item.appendChild(fill);
      progressBarsContainer.appendChild(item);
      progressFills.push(fill);
    }
  }

  function updateProgress(timestamp) {
    if (isVideoSlide || isSlideLoading || isPaused) {
      lastFrameTime = timestamp;
      progressFrame = requestAnimationFrame(updateProgress);
      return;
    }
    if (!lastFrameTime) lastFrameTime = timestamp;
    timeElapsed += timestamp - lastFrameTime;
    lastFrameTime = timestamp;

    const percentage = Math.min((timeElapsed / defaultDuration) * 100, 100);
    if (progressFills[currentSlideIndex]) progressFills[currentSlideIndex].style.width = percentage + '%';
    
    if (percentage >= 100) nextSlide();
    else progressFrame = requestAnimationFrame(updateProgress);
  }

  function applyTransition() {
    activeImg.style.transition = activeVideo.style.transition = modalTextContent.style.transition = 'none';
    
    if (transitionEffect === 'fade') {
      activeImg.style.opacity = activeVideo.style.opacity = modalTextContent.style.opacity = '0';
      
      // Tarayıcıyı stili uygulamaya zorla (Anlık parlama bug'ını çözer)
      void activeImg.offsetWidth;
      
      activeImg.style.transition = activeVideo.style.transition = modalTextContent.style.transition = 'opacity 0.3s ease';
      activeImg.style.opacity = activeVideo.style.opacity = modalTextContent.style.opacity = '1';
      
    } else if (transitionEffect === 'slide') {
      // Metne transform uygulamıyoruz, aksi halde CSS'teki 'translateY' ortalamasını bozar
      activeImg.style.transform = activeVideo.style.transform = 'scale(1.05)';
      modalTextContent.style.opacity = '0'; // Metin sadece fade-in ile gelsin
      
      void activeImg.offsetWidth;
      
      activeImg.style.transition = activeVideo.style.transition = 'transform 0.3s ease';
      modalTextContent.style.transition = 'opacity 0.3s ease';
      
      activeImg.style.transform = activeVideo.style.transform = 'scale(1)';
      modalTextContent.style.opacity = '1';
    }
  }

  function preloadNext(story, index) {
    const next = story.slides[index + 1];
    if(next && next.type === 'image' && next.image) {
      const img = new Image(); img.src = next.image;
    }
  }

  function loadSlide(story, index) {
    cancelAnimationFrame(progressFrame);
    isSlideLoading = true; isVideoSlide = false; isPaused = false;
    timeElapsed = 0; lastFrameTime = 0;

    if (!progressFills.length || progressFills.length !== story.slides.length) buildProgressBars(story.slides.length);
    progressFills.forEach((fill, i) => fill.style.width = i < index ? '100%' : '0%');

    const slide = story.slides[index];
    if (!slide) return;

    activeImg.style.display = activeVideo.style.display = 'none';
    activeVideo.pause(); activeVideo.removeAttribute('src');
    loader.style.display = 'block';
    bgBlur.style.opacity = '0';

    modalTitle.textContent = story.title || '';
    modalSubtitle.textContent = story.subtitle || '';
    modalAvatar.style.backgroundImage = story.avatar ? `url(${story.avatar})` : 'none';
    
    modalBodyText.innerHTML = slide.body_html || '';
    modalBodyText.style.color = slide.text_color;
    modalTextContent.className = 'story-modal-text-content ' + (slide.text_position || 'center');

    modalActionBtn.className = 'story-modal-action-btn';
    if (slide.action_type === 'product' && slide.product_variant_id) {
      modalActionBtn.textContent = (slide.button_text || 'Sepete Ekle') + (slide.product_price ? ` - ${slide.product_price}` : '');
      modalActionBtn.style.display = 'inline-flex';
      swipeUpIndicator.style.display = 'flex';
      modalActionBtn.onclick = (e) => { e.preventDefault(); e.stopPropagation(); handleAddToCart(slide.product_variant_id); };
    } else if (slide.action_type === 'link' && slide.link_url) {
      modalActionBtn.textContent = slide.button_text || 'İncele';
      modalActionBtn.style.display = 'inline-flex';
      swipeUpIndicator.style.display = 'flex';
      modalActionBtn.onclick = (e) => { e.stopPropagation(); window.location.href = slide.link_url; };
    } else {
      modalActionBtn.style.display = 'none';
      swipeUpIndicator.style.display = 'none';
    }

    if (enableBlur && (slide.image || slide.video_url)) {
       bgBlur.style.backgroundImage = `url(${slide.image || ''})`; 
    }

    if (slide.type === 'video' && slide.video_url) {
      isVideoSlide = true;
      muteBtn.style.display = 'flex';
      activeVideo.muted = isGlobalMuted;
      muteBtn.querySelector('.icon-muted').style.display = isGlobalMuted ? 'block' : 'none';
      muteBtn.querySelector('.icon-unmuted').style.display = isGlobalMuted ? 'none' : 'block';
      
      activeVideo.src = slide.video_url;
      activeVideo.load();
      activeVideo.oncanplay = () => {
        if(currentSlideIndex !== index) return;
        loader.style.display = 'none';
        activeVideo.style.display = 'block';
        if(enableBlur) bgBlur.style.opacity = '1';
        applyTransition(); activeVideo.play();
        isSlideLoading = false;
        progressFrame = requestAnimationFrame(updateProgress);
        preloadNext(story, index);
      };
      activeVideo.onerror = () => { if(currentSlideIndex === index) nextSlide(); };
    } else if (!slide.image && slide.body_html) {
      // YENİ EKLENEN BLOK: Sadece metin girilmiş ve görsel/video eklenmemişse
      muteBtn.style.display = 'none';
      loader.style.display = 'none';
      if(enableBlur) bgBlur.style.opacity = '0';
      activeImg.style.display = 'none';
      isSlideLoading = false;
      applyTransition();
      progressFrame = requestAnimationFrame(updateProgress);
      preloadNext(story, index);

    }else {
      muteBtn.style.display = 'none';
      activeImg.onload = () => {
        if(currentSlideIndex !== index) return;
        loader.style.display = 'none';
        activeImg.style.display = 'block';
        if(enableBlur) bgBlur.style.opacity = '1';
        isSlideLoading = false;
        applyTransition();
        progressFrame = requestAnimationFrame(updateProgress);
        preloadNext(story, index);
      };
      activeImg.onerror = () => { if(currentSlideIndex === index) nextSlide(); };
      activeImg.src = slide.image || '';
      if (activeImg.complete && activeImg.src) activeImg.onload();
    }
  }

  function handleAddToCart(variantId) {
    isPaused = true; if(isVideoSlide) activeVideo.pause();
    modalActionBtn.classList.add('loading'); modalActionBtn.textContent = 'Ekleniyor...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(res => res.json())
    .then(data => {
      modalActionBtn.classList.remove('loading'); modalActionBtn.classList.add('added');
      modalActionBtn.textContent = 'Sepete Eklendi!';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(() => { isPaused = false; if(isVideoSlide) activeVideo.play(); }, 1500);
    })
    .catch(err => {
      modalActionBtn.classList.remove('loading'); modalActionBtn.textContent = 'Hata Oluştu';
      setTimeout(() => { isPaused = false; if(isVideoSlide) activeVideo.play(); }, 1000);
    });
  }

  function triggerSwipeUpAction() {
     const slide = currentStory.slides[currentSlideIndex];
     if (slide.action_type === 'product' && slide.product_variant_id) handleAddToCart(slide.product_variant_id);
     else if (slide.action_type === 'link' && slide.link_url) window.location.href = slide.link_url;
  }

  activeVideo.addEventListener('timeupdate', () => {
    if (isVideoSlide && !isSlideLoading && !isPaused && progressFills[currentSlideIndex]) {
      progressFills[currentSlideIndex].style.width = (activeVideo.currentTime / activeVideo.duration) * 100 + '%';
    }
  });
  activeVideo.addEventListener('ended', () => { if (isVideoSlide) nextSlide(); });

  muteBtn.addEventListener('click', (e) => {
    e.stopPropagation(); isGlobalMuted = !isGlobalMuted;
    activeVideo.muted = isGlobalMuted;
    muteBtn.querySelector('.icon-muted').style.display = isGlobalMuted ? 'block' : 'none';
    muteBtn.querySelector('.icon-unmuted').style.display = isGlobalMuted ? 'none' : 'block';
  });

  // TIKLAMA / JEST / KAYDIRMA AYRIMI (KUSURSUZ YAPI)
  let touchStartX = 0, touchStartY = 0;

  modalBody.addEventListener('touchstart', e => {
     isSwiping = false;
     touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY;
  }, {passive: true});

  modalBody.addEventListener('touchmove', e => {
     isSwiping = true; // Parmağını hareket ettiriyorsa kaydırıyordur, tıklama iptal!
  }, {passive: true});

  modalBody.addEventListener('touchend', e => {
     if(!isSwiping) return; // Sadece tıklamışsa click eventine bırak.
     const touchEndX = e.changedTouches[0].clientX; const touchEndY = e.changedTouches[0].clientY;
     const deltaX = touchEndX - touchStartX; const deltaY = touchEndY - touchStartY;
     
     if (Math.abs(deltaY) > 50 && Math.abs(deltaY) > Math.abs(deltaX)) {
         if (deltaY > 0) closeOverlay(); // Aşağı kaydırma
         else triggerSwipeUpAction(); // Yukarı kaydırma
     } else if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
         if (deltaX > 0) prevSlide(); // Sağa kaydırma
         else nextSlide(); // Sola kaydırma
     }
  });

  // Tıklama (Click) İşlemleri
  nextBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    if(!isSwiping) nextSlide();
  });
  
  prevBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    if(!isSwiping) prevSlide();
  });

  // Basılı Tutarak Durdurma (Pause on Hold)
  function pauseStory() { isPaused = true; if(isVideoSlide) activeVideo.pause(); }
  function playStory() { isPaused = false; if(isVideoSlide) activeVideo.play(); }
  
  [prevBtn, nextBtn, modalBody].forEach(el => {
     el.addEventListener('mousedown', pauseStory);
     el.addEventListener('mouseup', playStory);
     el.addEventListener('mouseleave', playStory);
     el.addEventListener('touchstart', pauseStory, {passive: true});
     el.addEventListener('touchend', playStory);
  });

  function openStory(blockId) {
    currentStory = stories.find(s => s.id === blockId);
    if (!currentStory || !currentStory.slides.length) return;
    currentSlideIndex = 0;
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    loadSlide(currentStory, currentSlideIndex);
  }

  function closeOverlay() {
    cancelAnimationFrame(progressFrame);
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    activeVideo.pause(); activeVideo.removeAttribute('src');
  }

  function nextSlide() {
    if (currentSlideIndex < currentStory.slides.length - 1) loadSlide(currentStory, ++currentSlideIndex);
    else closeOverlay();
  }

  function prevSlide() {
    if (currentSlideIndex > 0) loadSlide(currentStory, --currentSlideIndex);
    else loadSlide(currentStory, 0);
  }

  section.querySelectorAll('.story-thumb-item').forEach(thumb => {
    thumb.addEventListener('click', () => openStory(thumb.getAttribute('data-block-id')));
  });

  closeBtn.addEventListener('click', closeOverlay);
  window.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeOverlay(); });
}

document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('.story-slider').forEach(initStorySlider));
document.addEventListener('shopify:section:load', (e) => { const s = e.target.querySelector('.story-slider'); if(s) initStorySlider(s); });

  } catch(e) { console.error(e); }
})();
})();
